import { Alert, AlertTitle, Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Error404 = () => {
  const navigate = useNavigate()
  return (
      <Alert severity="error" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height:'calc(100vh - 50px)'}}>
          <AlertTitle>404 Not Found</AlertTitle>
          Page searched does not exists<Button size="small" color="error" variant="contained" onClick={() => navigate('/')}>Go back to homepage</Button>
      </Alert>
  )
}

export default Error404